
export const Error404 = () => {
  return (
    <div>error404</div>
  )
}